import AppConfig from '../../../lib/AppConfig';
import { cleanApiError, handleResponse } from '../../../utils/handleResponse';
import { getAPIHeaders } from '../../../utils/helpers';
import { DataTableRequest } from '../types/requests/DataTableRequest';

export namespace MemberDataTableRepository {
	// addDataTableEntry
	export async function addDataTableEntry<T>(request: DataTableRequest<T>): Promise<void> {
		try {
			const url = `${AppConfig.api_url}/fineract-provider/api/v1/datatables/${request.dataTable}/${request.clientId}`;
			const headers = await getAPIHeaders();
			headers.set('Content-Type', 'application/json');

			const response = await fetch(url, {
				method: 'POST',
				body: JSON.stringify(request.data),
				headers,
			});

			await handleResponse(response);
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}

	// updateDataTableEntry with fallback to addDataTableEntry
	export async function updateDataTableEntry<T>(request: DataTableRequest<T>): Promise<void> {
		try {
			const url = `${AppConfig.api_url}/fineract-provider/api/v1/datatables/${request.dataTable}/${request.clientId}`;
			const headers = await getAPIHeaders();
			headers.set('Content-Type', 'application/json');

			const response = await fetch(url, {
				method: 'PUT',
				body: JSON.stringify(request.data),
				headers,
			});

			await handleResponse(response);
		} catch (error: any) {
			if (
				error?.httpStatusCode === '404' ||
				error?.errors?.some(
					(err: any) => err?.userMessageGlobalisationCode === 'error.msg.datatable.data.not.found',
				)
			) {
				console.log('Data not found for datatable, falling back to addDataTableEntry.');
				await addDataTableEntry(request); // Call addDataTableEntry if resource is not found
			} else {
				throw cleanApiError(error);
			}
		}
	}

	// updateDataTableEntry
	export async function getDataTableEntry<T>(request: DataTableRequest<T>): Promise<T[]> {
		try {
			const url = `${AppConfig.api_url}/fineract-provider/api/v1/datatables/${request.dataTable}/${request.clientId}`;

			const headers = await getAPIHeaders();

			const response = await fetch(url, {
				headers,
			});

			const data = await handleResponse(response);

			return data;
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}
}
